<template>
  <div v-html="TcciTexto" class="scroll"></div>
</template>

<script>
export default {
  name: "Terms",
  computed: {
    TcciTexto() {
      return this.$store.state.signup.clauses.TcciTexto;
    }
  },
  mounted() {
    if (!this.$store.state.signup.contract.TcciTexto) {
      this.$store.dispatch("signup/getContract", {});
    }
  }
};
</script>

<style lang="scss">
.scroll {
  padding-right: 10px;
  background-color: #fff;
  width: auto;
  height: 300px;
  overflow: auto;
  text-align: justify;
  p {
    color: #666 !important;
  }
}
</style> 